var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserBuilderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "ohl9f8qsma",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.708 9.791V2.916H2.917v6.875h4.791zm-5 1.25h5.209c.575 0 1.041-.466 1.041-1.041V2.708c0-.575-.466-1.042-1.041-1.042H2.708c-.575 0-1.041.467-1.041 1.042V10c0 .575.466 1.041 1.041 1.041zM7.708 17.083v-2.708H2.917v2.708h4.791zm-5 1.25h5.209c.575 0 1.041-.466 1.041-1.041v-3.126c0-.575-.466-1.041-1.041-1.041H2.708c-.575 0-1.041.466-1.041 1.041v3.125c0 .575.466 1.042 1.041 1.042zM17.083 6.667v-3.75h-4.791v3.75h4.791zm-5 1.25h5.209c.575 0 1.041-.467 1.041-1.042V2.708c0-.575-.466-1.042-1.041-1.042h-5.209c-.575 0-1.041.467-1.041 1.042v4.167c0 .575.466 1.042 1.041 1.042zM17.083 17.083V11.25h-4.791v5.833h4.791zm-5 1.25h5.209c.575 0 1.041-.466 1.041-1.041v-6.25c0-.575-.466-1.042-1.041-1.042h-5.209c-.575 0-1.041.466-1.041 1.041v6.25c0 .575.466 1.042 1.041 1.042z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ohl9f8qsma)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v30H0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBuilderIcon);
export default __webpack_public_path__ + "static/media/user-builder-icon.151a5c11e0b39b2c329f4790d04e98e4.svg";
export { ForwardRef as ReactComponent };